const setOrganizationName = (name) => {
    return {
        type: 'SET_ORGANIZATION_NAME',
        payload: name
    };
};

const setUserName = (name) => {
    return {
        type: 'SET_USER_NAME',
        payload: name
    };
};

const setFirstName = (name) => {
    return {
        type: 'SET_FIRST_NAME',
        payload: name
    };
};

const setLastName = (name) => {
    return {
        type: 'SET_LAST_NAME',
        payload: name
    };
};
const setUserInitials = (ins) => {
    return {
        type: 'SET_USER_INITIALS',
        payload: ins
    };
};

const setImpressionsStatus = (status) => {
    return {
        type: 'SET_IMPRESSIONS_STATUS',
        payload: status
    };
};

const setRushOrdersStatus = (status) => {
    return {
        type: 'SET_RUSH_ORDER_STATUS',
        payload: status
    };
};

const setSalesRep = (rep) => {
    return {
        type: 'SET_REP_FOR_ORDER',
        payload: rep
    };
};

const setOrderNotes = (notes) => {
    return {
        type: 'SET_ORDER_NOTES',
        payload: notes
    };
};

const setTextOnTop = (form) => {
    return {
        type: 'SET_TEXT_ON_TOP',
        payload: form
    };
};

const setTextOnBottom = (form) => {
    return {
        type: 'SET_TEXT_ON_BOTTOM',
        payload: form
    };
};

const isTextOnCase = (val) => {
    return {
        type: 'IS_TEXT_ON_CASE',
        payload: val
    };
};

const setForm = (form) => {
    return {
        type: 'SET_FORM_DATA',
        payload: form
    };
};

const setCarePlanSelected = (selected) => {
    return {
        type: 'SET_CARE_PLAN_SELECTED',
        payload: selected
    };
};
//eslint-disable-next-line
export default {
    setOrganizationName,
    setFirstName,
    setLastName,
    setUserName,
    setUserInitials,
    setImpressionsStatus,
    setRushOrdersStatus,
    setSalesRep,
    setOrderNotes,
    setTextOnTop,
    setTextOnBottom,
    isTextOnCase,
    setForm,
    setCarePlanSelected
};
